export const setUsersRole = (payload?: any) => ({
    type: "@saga/SET_USERS_ROLE",
    payload
});

